import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import EmailNotificationAction from "../../Actions/EmailNotificationAction";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import commonUtils from "../../helpers/commonUtils";

export default function EmailGroupCreatre(props) {
  const { emailGroupDetails, setEmailGroupDetails } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [groupName, setGroupName] = React.useState("");
  const [inputField, setInputField] = useState([""]);
  const [isEmailvalid, setIsEmailValid] = useState(true);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  useEffect(() => {
    if (emailGroupDetails !== "") {
      setGroupName(emailGroupDetails.groupTitle);
      setInputField(emailGroupDetails.emails);

      commonUtils.setIsEdit(true);
    } else {
      commonUtils.setIsEdit(false);
    }
  }, [emailGroupDetails]);

  const isInvalid = (_value) => {
    return _value
      .split(",")
      .some((item) => emailRegex.test(item.trim()) === false);
  };
  const handleEmailsSpilt = (textArea) => {
    const emails = textArea.split(",").map((email) => email.trim());
    const validEmails = emails.filter((email) => email !== "");
    return validEmails;
  };

  const handleTextareaChange = (event) => {
    event.preventDefault();
    if (!isEmailvalid && !isInvalid(event.target.value)) {
      setIsEmailValid(true);
    }
    setInputField(event.target.value.trim());
  };

  const handleEmailValidation = (event) => {
    event.preventDefault();

    if (isInvalid(event.target.value) && event.target.value !== "") {
      if (isEmailvalid) setIsEmailValid(false);
    } else {
      if (!isEmailvalid) setIsEmailValid(true);
    }
  };

  function handleSubmit(event) {
    event.preventDefault();
    let payLoad;
    let _emailsList;
    if (Array.isArray(inputField)) {
      _emailsList = inputField;
    } else {
      _emailsList = handleEmailsSpilt(inputField);
    }
    payLoad = {
      GroupTitle: groupName.trim(),
      Emails: _emailsList,
    };
    if (emailGroupDetails) {
      payLoad["ID"] = emailGroupDetails.id;
    }
    setGlobalSpinner(true);
    EmailNotificationAction.saveOrupdateEmailDistributionGroup(payLoad);
  }
  function handlePopOverClose() {
    setInputField([""]);
    setGroupName("");
    setEmailGroupDetails("");
    setIsEmailValid(true);
  }

  return (
    <div
      className="modal fade"
      id="addEmailGroup"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addEmailGroup"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addEmailSchedular">
              {emailGroupDetails === ""
                ? localization.emailpopOverHeader
                : localization.emailpopOverHeaderEdit}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addEmailSchedularModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="emailCreate" autoComplete="off" onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="groupName">{localization.groupName}</label>
                <input
                  className="form-control"
                  type="text"
                  id="groupName"
                  name="groupName"
                  required
                  value={groupName}
                  onChange={(e) => {
                    e.preventDefault();
                    if (groupName !== "") {
                      setGroupName(e.target.value);
                    } else {
                      setGroupName(e.target.value.trim());
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="groupName"
                  className={!isEmailvalid ? "text-danger" : ""}
                >
                  {localization.emails}
                </label>
                <textarea
                  className={`form-control danger ${
                    isEmailvalid ? "" : "border-danger"
                  }`}
                  required
                  id="exampleFormControlTextarea1"
                  rows="3"
                  onChange={handleTextareaChange}
                  onBlur={handleEmailValidation}
                  value={inputField}
                />
                {!isEmailvalid && (
                  <span className="text-danger">
                    {localization.enterValidEmail}
                  </span>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={!isEmailvalid}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
